import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

function FullLoader() {
  return (
    <div className="min-h-screen grid place-items-center bg-background" data-testid="auth-loading">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}

export function ProtectedRoute({ children, adminOnly = false, requireSub = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) return <FullLoader />;
  if (user === false) return <Navigate to="/login" state={{ from: location }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (requireSub && user.role !== "admin" && !user.is_subscribed) return <Navigate to="/subscribe" replace />;
  return children;
}
